import { render, staticRenderFns } from "./pathdetail.vue?vue&type=template&id=7da86132&"
import script from "./pathdetail.vue?vue&type=script&lang=js&"
export * from "./pathdetail.vue?vue&type=script&lang=js&"
import style0 from "./pathdetail.vue?vue&type=style&index=0&id=7da86132&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports